import { render, staticRenderFns } from "./business-team.vue?vue&type=template&id=3eb85a03&"
import script from "./business-team.vue?vue&type=script&lang=js&"
export * from "./business-team.vue?vue&type=script&lang=js&"
import style0 from "./business-team.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports